import { Workflow, useGetQuery } from '@gripp/shared-logic';
import { useEffect, useState } from 'react';

export const useWorkflow = (workflowId: string) => {
  const [workflow, setWorkflow] = useState<Workflow>();

  const { data, isLoading } = useGetQuery({
    modelName: 'workflow',
    query: GET_WORKFLOW,
    id: workflowId,
    options: {
      staleTime: 0,
      gcTime: 0,
      enabled: !!workflowId,
    },
  });

  useEffect(() => {
    if (!data) return;
    setWorkflow(data as Workflow);
  }, [data]);

  return { workflow, isLoading };
};

const GET_WORKFLOW = `
  query GetWorkflow($id: ID!) {
    getWorkflow(id: $id) {
      id
      name
      group {
        id
        name
      }
      workspaceAsset {
        id
      }
      trigger {
        type
        config
      }
      action {
        type
        config
      }
      disabledBetween {
        start
        end
      }
    }
  }
`;
